"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSTANTS = {};

exports.default = CONSTANTS;
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-imgix/lib/constants.js
// module id = 3810
// module chunks = 168707334958949